import { createRequestReducer } from "redux-request-state";

import * as actions from "./commission.actions";

export const commissions = createRequestReducer({
    begin: actions.REQUEST_COMMISSIONS,
    success: actions.RECEIVE_COMMISSIONS,
    failure: actions.ERROR_COMMISSIONS
});